<template>
  <div>
    <label v-if="label" class="data-name" :class="{ regular: regularLabel }">
      {{ label }}
    </label>
    <multiselect
      v-model="selectedOptions"
      :options="options"
      multiple
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="false"
      :placeholder="placeholder"
      label="name"
      track-by="name"
      :show-labels="false"
      @input="toggleSelected"
    >
      <template slot="selection" slot-scope="{ values, isOpen }">
        <span
          class="font-weight-normal font-14"
          v-if="values.length"
          v-show="!isOpen"
        >
          {{ selection }}
        </span>
      </template>
      <template slot="option" slot-scope="{ option }">
        <div class="input-group font-16 font-weight-normal">
          <input
            type="checkbox"
            class="checkbox option-input"
            :checked="isSelected(option)"
          />
          <label class="d-flex m-0">
            <span class="mt-1 pr-3 bg-white">
              <em class="ic-check"></em>
            </span>
            <div>
              {{ option.name }}
            </div>
          </label>
        </div>
      </template>
    </multiselect>
    <error v-if="error" variant="no-border" :message="customErrorMsg" />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Error from 'custom-error';
import CheckBox from 'CheckBox';
export default {
  name: 'CustomMultiSelect',
  components: {
    Error,
    CheckBox,
    Multiselect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia para el CustomDropDown',
        example: 'Seleccione',
      },
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    label: {
      type: String,
      default: () => '',
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Control para mostrar texto en regular',
        example: 'true',
      },
    },
  },
  data() {
    return {
      selectedOptions: this.value ? [...this.value] : [],
    };
  },
  computed: {
    selection() {
      return this.selectedOptions?.length
        ? this.selectedOptions.map((option) => option.name).join(', ')
        : '';
    },
  },
  methods: {
    isSelected(option) {
      return this.selectedOptions?.find((item) => item.id === option.id)
        ? true
        : false;
    },
    toggleSelected() {
      this.$emit('input', this.selectedOptions);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
@import '@/assets/scss/v2/brand_variables.scss';
span.invalid:not(input) {
  color: #e85c5c;
}

.input-label {
  height: 19px;
  text-align: left;
  font: 14px Lato;
  letter-spacing: 0;
  color: #727272;
  line-height: 19px;
}
.input-label.regular {
  font-weight: 400;
}
.custom-ddl div .v-select .vs__dropdown-toggle {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 2px solid #c5cdcf;
  opacity: 1;
  height: 38px;
}

.custom-ddl .vs__dropdown-menu {
  background: #fff;
  border: none;
  position: relative;
}
.custom-ddl :placeholder-shown,
.custom-ddl .vs__search::placeholder {
  color: #495057;
  opacity: 0.8;
  line-height: 1.6;
}
.bold-ddl :placeholder-shown,
.bold-ddl .vs__search::placeholder {
  color: black;
  font-weight: bold;
  line-height: 1.6;
}
.custom-ddl span.vs__selected,
.custom-ddl .vs__selected-options .vs__selected,
.custom-ddl .vs__dropdown-menu .vs__dropdown-option {
  font-weight: 400 !important;
}
.custom-ddl .was-Invalidated {
  border-radius: 4px;
  border: 1px solid #ff0018;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}
.v-select.custom-v-select {
  background-color: white;
}
.v-select.custom-v-select.was-Invalidated {
  background-color: #f7d7da;
}
.v-select.custom-v-select >>> .vs__open-indicator {
  cursor: pointer;
}
.custom-ddl >>> .v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}
.custom-v-select ::v-deep {
  background: white !important;
  .vs__dropdown-menu {
    width: auto !important;
    min-width: 100% !important;
  }
}

::v-deep input[type='checkbox']:checked + label span {
  background-color: #2db782 !important;
}

::v-deep input[type='checkbox']:checked + label span em {
  filter: brightness(0) invert(1);
}

::v-deep input[type='checkbox']:disabled + label span em {
  filter: invert(75%) sepia(10%) saturate(13%) hue-rotate(19deg) brightness(88%)
    contrast(84%);
}

::v-deep input[type='checkbox']:disabled + label span {
  background-color: #fff !important;
}

::v-deep input[type='checkbox']:checked:disabled + label span {
  background-color: #e2e2e2 !important;
}

::v-deep .multiselect__tag-icon:hover {
  background: $gray-400;
}
::v-deep .multiselect__tags {
  min-height: 36px !important;
  padding: 3px 40px 0 8px !important;
}
::v-deep .multiselect__option--highlight {
  background: $gray-400;
}

::v-deep .multiselect__input::placeholder {
  color: #333;
  font-weight: normal;
  opacity: 1;
}

::v-deep .multiselect__tags {
  padding: 6px 40px 0 8px !important;

  span {
    color: #333 !important;
  }
}

::v-deep .multiselect__element {
  label {
    div {
      margin-top: 5.5px !important;
      color: #333 !important;
    }
  }
}

.input-group .option-input {
  display: none;
}
.input-group .option-input + label span {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: -2px 10px 0 0;
  vertical-align: middle;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  cursor: pointer;
}
.input-group .option-input:checked + label span .ic-check {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' focusable='false' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 14 10' style='enable-background:new 0 0 14 10;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%232DB782;%7D%0A%3C/style%3E%3Cpath class='st0' d='M5.6,7.8L2.9,5.1C2.7,5,2.7,4.7,2.9,4.5L3.5,4c0.2-0.2,0.4-0.2,0.6,0l1.8,1.8l3.9-3.9c0.2-0.2,0.4-0.2,0.6,0 l0.6,0.6c0.2,0.2,0.2,0.4,0,0.6L6.2,7.8C6,8,5.7,8,5.6,7.8L5.6,7.8z'/%3E%3C/svg%3E%0A");
  background-size: cover;
  display: flex;
  width: 18px;
  height: 14px;
  margin: 2px auto;
}
.input-group .option-input:checked + label span .icon {
  display: flex;
  margin: 2px 3px;
  color: #fff;
  font-size: 13px;
}
</style>
